import { partial } from "lodash";
import { toJS } from "mobx";
import { LogEventLevel } from "@/telemetry/logDomain";

export enum LogLevel {
  DEBUG = 0,
  WARN = 10,
  ERROR = 20,
}

function parseLogLevel(s: string | null): LogLevel {
  switch (s) {
    case "0":
      return LogLevel.DEBUG;
    default:
      return LogLevel.WARN;
  }
}

let currentLevel: LogLevel = parseLogLevel(sessionStorage.getItem("logLevel"));

if (import.meta.env.DEV || new URLSearchParams(location.search).has("debug")) {
  setLogLevel(LogLevel.DEBUG);
}

if (import.meta.env.MODE === "test") {
  setLogLevel(LogLevel.WARN);
}

export function setLogLevel(level: LogLevel) {
  currentLevel = level;
  sessionStorage.setItem("logLevel", level.toString());
}

export function isDebugLoggingEnabled() {
  return currentLevel === LogLevel.DEBUG;
}

export type LogListener = (level: LogEventLevel, args: unknown[]) => void;

let logListener: LogListener | undefined;

export function setLogListener(listener: LogListener) {
  logListener = listener;
}

export function log(level: LogLevel, ...args: unknown[]) {
  if (level < currentLevel) {
    return;
  }
  const plain = args.map((a) => toJS(a));
  logToConsoleAndSentry(level, plain);
  if (level >= LogLevel.WARN) {
    logListener?.(level === LogLevel.ERROR ? "error" : "warn", plain);
  }
}

export function logToConsoleAndSentry(level: LogLevel, args: unknown[]) {
  switch (level) {
    case LogLevel.DEBUG:
      // eslint-disable-next-line no-console
      console.log(...args);
      break;
    case LogLevel.WARN:
    case LogLevel.ERROR:
      // eslint-disable-next-line no-console
      console.error(...args);
      break;
  }
}

export const logDebug = partial(log, LogLevel.DEBUG);
export const logWarn = partial(log, LogLevel.WARN);
export const logError = partial(log, LogLevel.ERROR);
